import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float, ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { min } from '@adornis/validation/functions/range.js';
import { mongo } from '../server/mongo.js';
import { Product } from './products.js';
import { User } from './user.js';

// create indices
export async function ensureTeachingIndexes(): Promise<void> {
  const teachingsCollection = mongo().collection('teachings');
  await teachingsCollection.createIndex({ productID: 1 });
  await teachingsCollection.createIndex({ lecturerID: 1 });
}

@Entity()
export class Teaching extends MongoEntity {
  static override _class = 'Teaching';
  static override _collectionName = 'teachings';

  @validate(nonOptional())
  @Field(type => ID)
  lecturerID!: string;

  // this can hold lecturers and referents
  @DataLoadedField(type => User, teaching => ({ _id: teaching.lecturerID as any }))
  lecturer: Maybe<User>;

  @validate(nonOptional())
  @Field(type => ID)
  productID!: string;

  @DataLoadedField(type => Product, teaching => ({ _id: teaching.productID as any }))
  product: Maybe<Product>;

  @Field(type => Date, { default: v => v ?? new Date() })
  createdAt!: Date;

  @Field(type => ID)
  contractID: Maybe<string>;

  @validate(min(0))
  @Field(type => Float)
  contractPrice: Maybe<number>;

  @Field(type => String)
  contractPriceWords: Maybe<string>;

  @Field(type => ID)
  signedContractFileID: Maybe<string>;

  override toString() {
    return `Lecturer: ${this.lecturerID} -> Product: ${this.productID}`;
  }
}
